// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as CustomSidebar from "../../../pricing-dashboard/view/components/library/reuseable-components/CustomSidebar.bs.js";
import * as CountryContext from "../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as Button$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/Button.bs.js";
import * as WorkSpaceContext from "../../../../../library/work-space/WorkSpaceContext.bs.js";
import * as ConfirmationModal from "../../../pricing-dashboard/view/components/components/sidebars/ConfirmationModal.bs.js";
import * as PlaceOrderGaConfig from "../../../place-order/app/helper/PlaceOrderGaConfig.bs.js";
import * as CustomerInfoSidebar from "./sidebars/CustomerInfoSidebar.bs.js";
import * as CustomerAssetsManager from "../assets/CustomerAssetsManager.bs.js";
import * as PlaceOrderContainerCmp from "../../../place-order/view/components/PlaceOrderContainerCmp.bs.js";
import * as CircularLoader$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/loaders/CircularLoader.bs.js";

function CustomerInfoCmp(Props) {
  var openSnackbar = Props.openSnackbar;
  var customer_id = Props.customer_id;
  var customer_data = Props.customer_data;
  var cashback_data = Props.cashback_data;
  var porter_gold_details_state = Props.porter_gold_details_state;
  var dispatch = Props.dispatch;
  var phone_number = Props.phone_number;
  var geo_region_items = Props.geo_region_items;
  var workspaceDispatch = WorkSpaceContext.useWorkSpace(undefined);
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  var match$1 = React.useState(function () {
        return false;
      });
  var setShowCustomerInfo = match$1[1];
  var match$2 = React.useState(function () {
        return false;
      });
  var changeDiscardModalState = match$2[1];
  var match$3 = React.useState(function () {
        return false;
      });
  var setRefresh = match$3[1];
  var match$4 = React.useState(function () {
        return false;
      });
  var setShowPlaceOrderPanel = match$4[1];
  var porterGoldLogo = CustomerAssetsManager.getImage("porter_gold_icon.png");
  var porterGoldLogoDisabled = CustomerAssetsManager.getImage("porter_gold_disabled_icon.png");
  var formData = customer_data.formData;
  var summary = customer_data.summary;
  var onClosePlaceOrderPanel = function (param) {
    return Curry._1(setShowPlaceOrderPanel, (function (param) {
                  return false;
                }));
  };
  var closeCustomerInfoSidebar = function (param) {
    return Curry._1(setShowCustomerInfo, (function (param) {
                  return false;
                }));
  };
  var cnfModalConfirmCb = function (param) {
    Curry._1(changeDiscardModalState, (function (param) {
            return false;
          }));
    return Curry._1(setShowCustomerInfo, (function (param) {
                  return false;
                }));
  };
  var cnfModalCancelCb = function (param) {
    return Curry._1(changeDiscardModalState, (function (param) {
                  return false;
                }));
  };
  if (match$3[0]) {
    return null;
  }
  var tmp;
  tmp = country.TAG === /* India */1 ? React.createElement("img", {
          alt: "port gold",
          src: summary.is_portergold_active ? porterGoldLogo : porterGoldLogoDisabled
        }) : null;
  var match$5 = formData.temporarily_deactivated.attribute_value;
  var tmp$1 = match$5 === "false" ? "active" : "inactive";
  var city = summary.city;
  var match$6 = summary.is_portergold_active;
  var tmp$2;
  tmp$2 = country.TAG === /* India */1 && match$6 ? (
      typeof porter_gold_details_state === "number" ? React.createElement("div", {
              className: "info-text"
            }, React.createElement(CircularLoader$Catalyst.make, {})) : (
          porter_gold_details_state.TAG === /* Data */0 ? React.createElement("div", {
                  className: "info-text"
                }, React.createElement("p", undefined, porter_gold_details_state._0.message)) : null
        )
    ) : null;
  var match$7 = summary.referral;
  var tmp$3;
  tmp$3 = country.TAG === /* India */1 && match$7 !== undefined ? React.createElement("div", {
          className: "info-text"
        }, React.createElement("p", undefined, match$7)) : null;
  var tmp$4;
  tmp$4 = country.TAG === /* India */1 ? false : formData.temporarily_deactivated.attribute_value === "true";
  return React.createElement(React.Fragment, undefined, React.createElement("div", {
                  className: "customer-info-card"
                }, React.createElement("div", {
                      className: "card-container"
                    }, tmp, React.createElement("div", {
                          className: "card"
                        }, React.createElement("p", {
                              className: "title"
                            }, "Customer Information", React.createElement("span", {
                                  onClick: (function (param) {
                                      return Curry._1(setShowCustomerInfo, (function (param) {
                                                    return true;
                                                  }));
                                    })
                                }, "View Details")), React.createElement("div", {
                              className: "info-text"
                            }, React.createElement("p", {
                                  className: "name"
                                }, summary.name, React.createElement("span", {
                                      className: tmp$1
                                    }, formData.temporarily_deactivated.attribute_value === "true" ? "in-active" : "active"), summary.is_business_customer ? React.createElement("span", {
                                        className: "business_cusromer"
                                      }, "PFE User") : null)), React.createElement("div", {
                              className: "info-text"
                            }, React.createElement("p", undefined, summary.mobile)), formData.email.attribute_value.length > 0 ? React.createElement("div", {
                                className: "info-text"
                              }, React.createElement("p", undefined, formData.email.attribute_value)) : null, city !== undefined ? React.createElement("div", {
                                className: "info-text"
                              }, React.createElement("p", undefined, city)) : null, tmp$2, tmp$3, React.createElement("div", {
                              className: "redirect-text",
                              onClick: (function (_event) {
                                  return Curry._2(workspaceDispatch.addTab, {
                                              TAG: /* DriverLeadPage */49,
                                              _0: summary.mobile
                                            }, false);
                                })
                            }, React.createElement("a", undefined, "View Partner Lead Page")))), React.createElement(Button$Catalyst.make, {
                      text: "Place Order",
                      cb: (function (param) {
                          if (country.TAG === /* India */1) {
                            return Curry._2(workspaceDispatch.addTab, {
                                        TAG: /* PlaceOrder */48,
                                        _0: customer_id
                                      }, false);
                          }
                          PlaceOrderGaConfig.publishEvent({
                                category: /* PlaceOrder */0,
                                action: "Place Order Button Click Success",
                                label: "1_" + phone_number,
                                value: undefined,
                                nonInteraction: undefined
                              }, country);
                          return Curry._1(setShowPlaceOrderPanel, (function (param) {
                                        return true;
                                      }));
                        }),
                      className: "btn-primary apply-button",
                      disabled: tmp$4
                    }), React.createElement("div", undefined, React.createElement(CustomSidebar.make, {
                          is_open: match$1[0],
                          on_back_drop_click: (function (param) {
                              return Curry._1(changeDiscardModalState, (function (param) {
                                            return true;
                                          }));
                            }),
                          children: React.createElement(CustomerInfoSidebar.make, {
                                customer_data: customer_data,
                                cashback_data: cashback_data,
                                customer_id: customer_id,
                                phone_number: phone_number,
                                geo_region_items: geo_region_items,
                                openSnackbar: openSnackbar,
                                dispatch: dispatch,
                                closeCustomerInfoSidebar: closeCustomerInfoSidebar,
                                pageRefresh: (function (param) {
                                    Curry._1(setRefresh, (function (param) {
                                            return true;
                                          }));
                                    return Curry._1(setRefresh, (function (param) {
                                                  return false;
                                                }));
                                  })
                              })
                        }), React.createElement(ConfirmationModal.make, {
                          title: "Discard Changes",
                          isOpen: match$2[0],
                          onConfirmCb: cnfModalConfirmCb,
                          onCancelCb: cnfModalCancelCb,
                          confirm_button_title: "Yes, Discard",
                          cancel_button_title: "No, Cancel",
                          children: React.createElement("div", undefined, "You are about to leave this page. All the changes will be lost. Are you sure you wish to exit?")
                        }))), match$4[0] ? React.createElement(PlaceOrderContainerCmp.make, {
                    onClosePlaceOrderPanel: onClosePlaceOrderPanel,
                    customerInfo: {
                      mobile: summary.mobile,
                      customerId: customer_id
                    }
                  }) : null);
}

var make = CustomerInfoCmp;

export {
  make ,
  
}
/* react Not a pure module */
